<template>
    <div class="reportCstmSaleInfo defaultReport">
        <div class="filter-box">
            <div class="filter-bnts ">
                <div class="bnt verticalCenter" :class="{selected:queryType==false}" @click="nowadays()" >
                    <div class="title">
                        <span>今天 <br/>({{userInfo.Rpt_Date}})</span>
                    </div>
                </div>
                <div class="bnt verticalCenter" :class="{selected:queryType==true}" @click="queryType=true" v-if="ReportDataFromDays>=0">
                    <div class="title">
                        <span>按日期范围</span>
                    </div>
                </div>
                <div class="inline-block" v-if="ReportDataFromDays>=0">
                    <el-date-picker class="from-date" :editable="false"
                        v-model="businessHours"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="defaultTime"
                        @change="change"
                        :disabled='queryType==false'
                        :disabled-date="disabledDate"
                    > </el-date-picker>
                </div>
                <div class="inline-block" >
                    <div class="flex-box">
                        <div class="lable-txt">菜品类别:</div>
                        <div class="from-input" style="width: 180px;">
                            <select-tree v-model="categoryIds" placeholder="请选择" :data="treeFoodMainCategory" title="菜品类别选择">
                            </select-tree>
                        </div>
                    </div>
                </div>
                <div class="inline-block" >
                    <div class="flex-box">
                        <el-select class="search-type" v-model="searchType" placeholder="按菜品" >
                            <el-option :value="0" label="按菜品"></el-option>
                            <el-option :value="1" label="按卡号"></el-option>
                            <el-option :value="2" label="按客户姓名"></el-option>
                            <el-option :value="3" label="按手机号"></el-option>
                            <el-option :value="4" label="卡类"></el-option>
                        </el-select>
                        <div class="from-input search-input">
                            <input-pattern type="text" pattern="number" v-if="searchType==3" v-model="searchText"  placeholder="模糊检索" />
                            <input type="text" v-else v-model="searchText"  placeholder="模糊检索" />
                        </div>
                        <div class="search-flex">
                            <div class="bnt-search" @click="loadData()" >查询</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-bnts">
                <div class="bnt" @click="exportExcel()"><i class="iconfont icon-daochu"></i>导出报表</div>
            </div>
        </div>
        <div class="content-box clearfix">
            <div class="table-box grey-table" ref="tableBox">
                <el-table class="el-table--scrollable-y" ref="tableEl" id="billtableEl" :data="tableListPage" border 
                    @current-change="handleCurrentChange"
                    :row-class-name="tableRowClass"
                    @sort-change="sortChange" 
                    style="width: 100%;"  v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}" :default-sort = "{prop: 'date', order: 'descending'}" >
                    <el-table-column sortable prop="Member_CardNo" label="卡号" min-width="100" align="left"></el-table-column>
                    <el-table-column sortable prop="Cstm_Name" label="客户姓名" min-width="100" align="left"></el-table-column>
                    <el-table-column sortable prop="Mobile" label="手机号" min-width="90" align="left"></el-table-column>
                    <el-table-column sortable prop="Member_CardKind" label="卡类" min-width="100" align="left"></el-table-column>
                    <el-table-column sortable prop="SubKind_Name" label="菜品类别" min-width="100" align="left"></el-table-column>
                    <el-table-column sortable prop="Eat_XFCode" label="菜品编码" min-width="100" align="left"></el-table-column>
                    <el-table-column sortable prop="Eat_XFName" label="菜品名称" min-width="100" align="left">
                        <template #default="scope">
                            <span class="link" @click="orderDetail(scope.row)">{{scope.row.Eat_XFName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="Eat_XFSize" label="单位" min-width="80" align="left"></el-table-column>
                    <el-table-column sortable prop="Eat_SetPrice" label="定价" min-width="80" :formatter="priceFormat" data-format="number" align="right"></el-table-column>
                    <el-table-column sortable prop="TotalFoodCount" label="销售数量" min-width="90" :formatter="priceFormat" data-format="number" align="right"></el-table-column>
                    <el-table-column sortable prop="SaleMoney" label="销售总额" min-width="90" :formatter="priceFormat" data-format="number" align="right"></el-table-column>
                    <el-table-column sortable prop="CheckMoney" label="折后金额" min-width="90" :formatter="priceFormat" data-format="number" align="right"></el-table-column>
                    <el-table-column sortable prop="FactMoney" label="实收额" min-width="90" :formatter="priceFormat" data-format="number" align="right"></el-table-column>
                </el-table>
            </div>
            <div class="block">
                <table-page-btn class="fy" :data="tableFilter" 
                    :default-index="currentPage" 
                    @current-change="(index)=>currentPage=index"
                    @page-change="(list)=>tableListPage=list" 
                    :page-size="pagesize"></table-page-btn>
            </div>
        </div>
     </div>
</template>

<script>

/**客户消费菜品统计表 */
export default {
    name:'reportCstmSaleInfo',
    data(){
        return {
            pagesize:9,//每页的数据条数
            currentPage:1,//默认开始页面
            istag: true,
            userInfo:'',
            /**表格数据 */ 
            tableList:[],
            tableListCopy:[],
            tableListPage:[],
            //排序
            sortable:null,
            /**默认日期范围 */
            defaultTime:[new Date(),new Date()],
            /**选中日期范围 */
            businessHours:[new Date(),new Date()],
            /**true: 日期范围    false：当前营业数据*/
            queryType:false,
            /**菜品数据 */
            posFoodData:[],
            /**菜品分类id */
            categoryIds:[],
            /**检索类型 0按菜品 1按卡号 2按客户姓名 3按手机号 4卡类*/
            searchType:0,
            //模糊检索
            searchText:'',
        }
    },
    computed:{
        //限制门店用户查看几天以内的报表, -1:不能查看历史数据，0:不限制，大于0：限制查看几天内的报表
        ReportDataFromDays(){
            return this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserViewReportDataFromDays||0
        },
        /**筛选 或 排序 */
        tableFilter(){
            let list=Object.assign([],this.tableList);
            if(list.length>0){
                if(this.categoryIds?.length>0){//类别
                    list=list.filter(it=>this.categoryIds.includes(it.SubKind_ID));
                }

                let text=(this.searchText||"").trim().toUpperCase();
                if(text){
                    if(this.searchType==1){//按卡号
                        list=list.filter(it=>(it.Member_CardNo||"").toUpperCase().indexOf(text)>=0);
                    }else if(this.searchType==2){//按客户姓名
                        list=list.filter(it=>(it.Cstm_Name||"").toUpperCase().indexOf(text)>=0);
                    }else if(this.searchType==3){//按手机号
                        list=list.filter(it=>(it.Mobile||"").toUpperCase().indexOf(text)>=0);
                    }else if(this.searchType==4){//卡类
                        list=list.filter(it=>(it.Member_CardKind||"").toUpperCase().indexOf(text)>=0);
                    }else{//按菜品
                        list=list.filter(it=>(it.Eat_XFCode||"").toUpperCase().indexOf(text)>=0 || (it.Eat_XFName||"").toUpperCase().indexOf(text)>=0);
                    }
                }
            }
            if(this.sortable && this.sortable.order){
                let sorttype=this.sortable.order=='ascending'?'asc':'desc';

                list.order(this.sortable.prop,sorttype);
            } 
            return list;
        },
        //分类数据
        treeFoodMainCategory(){
            let foodMainCategory=[];
            this.posFoodData?.forEach(item=>{
                let depart={
                    id:item.MainCategory_ID,
                    name:item.MainCategory_Name,
                    children:[],
                    Hierarchy:1
                }
                if(item.FoodSubCategorys){
                    item.FoodSubCategorys.forEach(eat=>{
                        let chieat={
                            id:eat.SubCategory_ID,
                            name:eat.SubCategory_Name,
                            Hierarchy:2
                        }
                        depart.children.push(chieat)
                    })
                }
                foodMainCategory.push(depart)
            })
            return [{
                id:1,
                name:"全选",
                children:foodMainCategory
            }];
        },
    },
    mounted(){
        this.userInfo = this.$auth.getUserInfo();
        this.nowadays();
        //菜品数据结构
        this.$cacheData.AllPosFoods().then((d)=>{
            this.posFoodData=d;
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
        })
        this.$nextTick(()=>{
            this.loadData();
        });
    },
    methods:{
        disabledDate(d){
            if(this.ReportDataFromDays>0 && this.userInfo.Rpt_Date){
                const oneDay =  24 * 3600 * 1000;
                const day = this.ReportDataFromDays * oneDay;
                let maxDate=new Date(this.userInfo.Rpt_Date).getTime()-oneDay;
                let minDate=maxDate-day;
                if(typeof(d)=="string"){
                    d=new Date(new Date(d).Format("yyyy-MM-dd"));
                }
                if(minDate>=d.getTime() || maxDate<d.getTime()){
                    return true;
                }
            }
            return false;
        },
        /**计算 一页显示多少条数据 */
        setTablePageSize(){
            if(this.$refs.tableBox){
                let height=this.$refs.tableBox.clientHeight - 50;
                this.pagesize=parseInt(height/50);
            }
        },
        /**账单数据排序 */
        sortChange(column){
            this.sortable=column;
        },
        /**Excel导出 */
        exportExcel(){
            if(!this.$cacheData?.globalVariable?.GlobalSysSetting.AllowUserPrintReports){
                this.$message.warning('您没有导出报表权限，请先分配权限！');
                return;
            }
            this.$excelCommon.elTableToExcel({
                elTable:this.$refs.tableEl,
                titleName:"客户消费菜品统计表",
                list:this.tableList
            })
        },
        /**今日 */
        nowadays(){
            this.queryType=false
            let Rpt_Date=new Date(this.userInfo.Rpt_Date);
            Rpt_Date.setDate(Rpt_Date.getDate()-1)
            this.businessHours=[Rpt_Date.Format("yyyy-MM-dd"),Rpt_Date.Format("yyyy-MM-dd")]
        },
        change(){
            if(this.queryType==false){
                this.queryType=true
            }
        },
        /*单价格式 截取两位小数 */
        priceFormat(row, column, cellValue){
            if(isNaN(cellValue)){
                return ""
            }else{
                return parseFloat(parseFloat(cellValue).toFixed(2));
            }
        },
        /*时间格式 */
        dateFormat(row, column, cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm:ss');
        },
        /**查询 */
        loadData(){
            let time = JSON.parse(JSON.stringify(this.businessHours));
            let param={
                User_ID:this.userInfo?.User_ID,
                Operator_Name:this.userInfo?.Login_Name,
                DateRange_YN:this.queryType,//是否日期范围查询  true: 日期范围    false：当前营业数据
                Begin_Date:new Date(time[0]).Format("yyyy-MM-dd"),//开始日期
                End_Date:new Date(time[1]).Format("yyyy-MM-dd"), //结束日期
            }
            if(this.queryType && (this.disabledDate(param.Begin_Date) || this.disabledDate(param.End_Date)) ){
                this.$message.warning("查询日期超过范围");
                return;
            }
            const loading = this.$loading({
                text: "查询中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.MemberSaleInfoReport",param,false).then((d)=>{
                loading.close();
                console.log('客户消费菜品统计表返回:',d)
                if(d.ResponseHeader.ResultCode==0){
                    this.oldParam={
                        businessHours:this.businessHours,
                        queryType:this.queryType
                    };
                    this.tableList=d.ResponseBody;
                    this.setTablePageSize()
                    this.currentPage=1
                }else{
                    this.tableList=[];
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error(e);
                console.log(e);
            })
        },
        //穿透到 明细报表
        orderDetail(row){
            this.$emit("addFrame",{
                key:"memberSaleBillListReport",
                data:{
                    businessHours:this.oldParam.businessHours,
                    queryType:this.oldParam.queryType,
                    Cstm_Name:row.Cstm_Name,
                    Eat_XFBMID:row.Eat_XFBMID
                },
                title:'账单列表',
                url:"billCheckReport"
            });
        },
        //奇偶行背景色不同
        setCurrent(row) {
            this.$refs.tableEl.setCurrentRow(row);
        },
        handleCurrentChange(val) {
            this.currentRow = val;
        },
        tableRowClass({row, rowIndex}) {
            if ((rowIndex + 1) % 2 === 0) {
                return 'success-row';
            }
            return '';
        }
    }
}
</script>

<style lang="scss" >
@import './reportCstmSaleInfo.scss'
</style>